import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { IoCloseCircle } from 'react-icons/io5';
import {
    MdClose,
    MdOpenInFull,
    MdCloseFullscreen,
    MdExitToApp,
    MdKeyboardArrowDown,
    MdKeyboardArrowUp,
    MdOutlineBookmark,
    MdOutlineBookmarkBorder,
    MdOutlineCalculate,
    MdOutlineKeyboard,
    MdOutlineLocationOn,
    // MdOutlinePlayCircle,
    MdSuperscript,
    MdInfo
} from 'react-icons/md';
import { IoMdRadioButtonOn, IoMdRadioButtonOff, IoMdInformationCircleOutline } from "react-icons/io";
import moment from 'moment';
// import Player from '@vimeo/player';
import Button from 'components/Button2';
import TextInput from 'components/TextInput';
import Loader from 'components/Loader';
// import Popup from 'components/Popup';
import axios from 'config/axios';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { setError } from 'store/error';
import { MULTIPLE_CHOICES } from 'global/constants';
import { getDeviceOS } from 'global/os';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';
import './index.css';

import 'katex/dist/katex.min.css';
import renderMathInElement from "katex/dist/contrib/auto-render.js";

function DigitalACTReview() {
    const [studentName, setStudentName] = useState('');
    const [testModules, setTestModules] = useState(null);
    const [moduleIndex, setModuleIndex] = useState(0);
    const [questionIndex, setQuestionIndex] = useState(0);
    const [moduleSelectOpen, setModuleSelectOpen] = useState(false);
    const [directionsOpen, setDirectionsOpen] = useState(false);
    const [navigatorOpen, setNavigatorOpen] = useState(false);
    const [calculator, setCalculator] = useState(null);
    const [calculatorOpen, setCalculatorOpen] = useState(false);
    const [calculatorFull, setCalculatorFull] = useState(false);
    const [showAnswer, setShowAnswer] = useState(false);
    const [notScored, setNotScored] = useState(false);
    const [notScoredHover, setNotScoredHover] = useState(false);
    const [navigatorNotScored, setNavigatorNotScored] = useState(false);
    const [navigatorNotScoredHover, setNavigatorNotScoredHover] = useState(false);
    const [annotations, setAnnotations] = useState([]);
    const [fullPassage, setFullPassage] = useState<{
        html?: string;
        preview?: string;
    } | null>(null);
    const [highlighting, setHighlighting] = useState<Array<{
        passageId?: string;
        html?: string;
        preview?: string;
    }>>([]);
    // const [player, setPlayer] = useState(null);
    // const [explanationVideo, setExplanationVideo] = useState(null);
    const [modeInfo, setModeInfo] = useState(false);
    const [modeInfoHover, setModeInfoHover] = useState(false);

    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    // const { organization } = useAppSelector(state => state.organization);
    const { testId } = useParams();
    const moduleSelectRef = useOutsideClickHandler(() => setTimeout(() => setModuleSelectOpen(false), 10));
    const directionsRef = useOutsideClickHandler(() => setTimeout(() => setDirectionsOpen(false), 10));
    const passageContainerRef = useRef(null);
    const navigatorRef = useOutsideClickHandler(() => 
        setTimeout(() => {
            setNavigatorOpen(false);
            setNavigatorNotScored(false);
        }, 10)
    );
    // const explanationRef = useOutsideClickHandler(() => setExplanationVideo(null));

    const prevQuestion = () => {
        if (questionIndex > 0) {
            setQuestionIndex(questionIndex - 1);
        }
        else if (moduleIndex > 0) {
            setQuestionIndex(testModules[moduleIndex - 1].questions.length - 1);
            setModuleIndex(moduleIndex - 1);
        }
    }

    const nextQuestion = () => {
        if (questionIndex < testModules[moduleIndex].questions.length - 1) {
            setQuestionIndex(questionIndex + 1);
        }
        else if (moduleIndex < testModules.length - 1) {
            setModuleIndex(moduleIndex + 1);
            setQuestionIndex(0);
        }
        else {
            // exit the review
            navigate(-1);
        }
    }

    const goToQuestion = (index: number) => {
        setQuestionIndex(index);

        let passages = document.getElementById('digitalACTReview__passages');
        let question = document.getElementById('digitalACTReview__questionChoices');

        if (passages) passages.scrollTop = 0;
        if (question) question.scrollTop = 0;
    }

    const formatTime = (time: number) => {
        const duration = moment.duration(time, 'seconds');

        const hours = duration.hours();
        const minutes = (hours && duration.minutes() < 10) ? `0${duration.minutes()}` : duration.minutes();
        const seconds = duration.seconds() < 10 ? `0${duration.seconds()}` : duration.seconds();

        return hours ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`;
    }

    const generateHightlightIndexing = ({id: passageId, indices, passageFigures = []}) => {
        for (let j = 0; j < indices.length; j++){
            const passage = document.getElementById(passageId);
            let passageHTML = '';
            let passagePreview = '';
            const { startIndex, endIndex } = indices[j];
            let startOffset = startIndex
            let endOffset = endIndex
            let lastIndex = 0;

            for (let i = 0; i < passage.childNodes.length; i++) {
                const childNode = passage.childNodes[i];

                if (j === 2) console.log(childNode);
    
                if (childNode.hasChildNodes()) {
                    // const { innerHTML, textContent } = childNode.firstChild.parentElement;
                    const { outerHTML: innerHTML, textContent } = childNode.firstChild.parentElement;
                    const indexOffset = innerHTML.indexOf(textContent);
                    // 이미지 삽입을 위한 passageFigure 검사
                    const currentFigure = passageFigures.find(fig => fig.index === lastIndex);
                    if (currentFigure) {
                        passageHTML += `
                            <div style="width:100%; overflow:hidden; margin:10px 0;"><img src="${currentFigure.figure.image}" alt="figure" style="width:100%; height:100%; object-fit:contain;" /></div>
                        `;                    
                    }

                    if (indexOffset === -1) {
                        passageHTML += innerHTML;
                        break;
                    }
    
                    passageHTML += innerHTML.slice(0, indexOffset);
    
                    if (startOffset >= lastIndex && endOffset <= lastIndex + textContent.length) {
                        passageHTML += textContent.slice(0, startOffset - lastIndex);
                        passageHTML += '<mark>';
                        passageHTML += textContent.slice(startOffset - lastIndex, endOffset - lastIndex);
                        passageHTML += '</mark>';
                        passageHTML += textContent.slice(endOffset - lastIndex, textContent.length);
                        passagePreview += innerHTML.slice(0, indexOffset);
                        passagePreview += textContent.slice(startOffset - lastIndex, endOffset - lastIndex);
                        passagePreview += innerHTML.slice(indexOffset + textContent.length);
                    }
                    else if (startOffset >= lastIndex && startOffset < lastIndex + textContent.length) {
                        passageHTML += textContent.slice(0, startOffset - lastIndex);
                        passageHTML += '<mark>';
                        passageHTML += textContent.slice(startOffset - lastIndex, textContent.length);
                        passageHTML += '</mark>';
                        passagePreview += innerHTML.slice(0, indexOffset);
                        passagePreview += textContent.slice(startOffset - lastIndex, textContent.length);
                        passagePreview += innerHTML.slice(indexOffset + textContent.length);
                    }
                    else if (endOffset >= lastIndex && endOffset < lastIndex + textContent.length) {
                        passageHTML += '<mark>';
                        passageHTML += textContent.slice(0, endOffset - lastIndex);
                        passageHTML += '</mark>';
                        passageHTML += textContent.slice(endOffset - lastIndex, textContent.length);
                        passagePreview += innerHTML.slice(0, indexOffset);
                        passagePreview += textContent.slice(0, endOffset - lastIndex);
                        passagePreview += innerHTML.slice(indexOffset + textContent.length);
                    }
                    else if (startOffset <= lastIndex && endOffset >= lastIndex + textContent.length) {
                        passageHTML += '<mark>';
                        passageHTML += textContent;
                        passageHTML += '</mark>';
                        passagePreview += innerHTML.slice(0, indexOffset);
                        passagePreview += textContent;
                        passagePreview += innerHTML.slice(indexOffset + textContent.length);
                    }
                    else {
                        passageHTML += textContent;
                    }
    
                    passageHTML += innerHTML.slice(indexOffset + textContent.length);
                    
                    lastIndex += textContent.length;
                }
                else {
                    const { textContent } = childNode;
    
                    if (startOffset >= lastIndex && endOffset <= lastIndex + textContent.length) {
                        passageHTML += textContent.slice(0, startOffset - lastIndex);
                        passageHTML += '<mark>';
                        passageHTML += textContent.slice(startOffset - lastIndex, endOffset - lastIndex);
                        passageHTML += '</mark>';
                        passageHTML += textContent.slice(endOffset - lastIndex, textContent.length);
                        passagePreview += textContent.slice(startOffset - lastIndex, endOffset - lastIndex);
                    }
                    else if (startOffset >= lastIndex && startOffset < lastIndex + textContent.length) {
                        passageHTML += textContent.slice(0, startOffset - lastIndex);
                        passageHTML += '<mark>';
                        passageHTML += textContent.slice(startOffset - lastIndex, textContent.length);
                        passageHTML += '</mark>';
                        passagePreview += textContent.slice(startOffset - lastIndex, textContent.length);
                    }
                    else if (endOffset >= lastIndex && endOffset < lastIndex + textContent.length) {
                        passageHTML += '<mark>';
                        passageHTML += textContent.slice(0, endOffset - lastIndex);
                        passageHTML += '</mark>';
                        passageHTML += textContent.slice(endOffset - lastIndex, textContent.length);
                        passagePreview += textContent.slice(0, endOffset - lastIndex);
                    }
                    else if (startOffset <= lastIndex && endOffset >= lastIndex + textContent.length) {
                        passageHTML += '<mark>';
                        passageHTML += textContent;
                        passageHTML += '</mark>';
                        passagePreview += textContent;
                    }
                    else {
                        passageHTML += textContent;
                    }
    
                    lastIndex += textContent.length;
                }
            }
            // const currentFigure = passageFigures.find(fig => fig.index === lastIndex);
            // if (currentFigure) {
            //     passageHTML += `
            //         <div style="width:100%; overflow:hidden; margin:10px 0;"><img src="${currentFigure.figure.image}" alt="figure" style="width:100%; height:100%; object-fit:contain;" /></div>
            //     `;                    
            // }
            setHighlighting(prev => [...(prev || []), { 
                passageId: passageId,
                html: passageHTML, 
                preview: passagePreview 
            }]);
        }

    };

    const getPassageWithFigure = ({id: passageId, passageFigures = []}) => {
        const passage = document.getElementById(passageId);
        let passageHTML = '';
        let lastIndex = 0;

        for (let i = 0; i < passage.childNodes.length; i++) {
            const childNode = passage.childNodes[i];

            // if (j === 2) console.log(childNode);

            if (childNode.hasChildNodes()) {
                // const { innerHTML, textContent } = childNode.firstChild.parentElement;
                const { outerHTML: innerHTML, textContent } = childNode.firstChild.parentElement;
                const indexOffset = innerHTML.indexOf(textContent);
                // 이미지 삽입을 위한 passageFigure 검사
                const currentFigure = passageFigures.find(fig => fig.index === lastIndex);
                if (currentFigure) {
                    passageHTML += `<div style="width:100%; overflow:hidden; margin:10px 0;"><img src="${currentFigure.figure.image}" alt="figure" style="width:100%; height:100%; object-fit:contain;" /></div>`;                    
                }

                passageHTML += innerHTML
                // passageHTML += innerHTML.slice(0, indexOffset);
                // passageHTML += textContent;
                // passageHTML += innerHTML.slice(indexOffset + textContent.length);
                lastIndex += textContent.length;
            }
            else {
                const { textContent } = childNode;
                passageHTML += textContent;
                lastIndex += textContent.length;
            }
        }
        // const currentFigure = passageFigures.find(fig => fig.index === lastIndex);

        // if (currentFigure) {
        //     passageHTML += `<div style="width:100%; overflow:hidden; margin:10px 0;"><img src="${currentFigure.figure.image}" alt="figure" style="width:100%; height:100%; object-fit:contain;" /></div>`;                    
        // }
        setFullPassage({
            html: passageHTML
        });

    };

    const generateAnnotation = () => {
        const newAnnotations = [ ...testModules[moduleIndex].answers[questionIndex].annotations ];

        for (let i = 0; i < newAnnotations.length; i++) {
            const {
                passageId,
                startIndex,
                endIndex
            } = newAnnotations[i];

            const passage = document.getElementById(`passage ${passageId}`);
            if (!passage) {
                return;
            }

            let passageHTML = '';
            let passagePreview = '';
            let lastIndex = 0;
            for (let i = 0; i < passage.childNodes.length; i++) {
                const childNode = passage.childNodes[i];

                if (childNode.hasChildNodes()) {
                    if (childNode.firstChild.nodeName === 'IMG') {
                        passageHTML += childNode.firstChild.parentElement.outerHTML;
                    }
                    else{
                        // const { innerHTML, textContent } = childNode.firstChild.parentElement;
                        const { outerHTML: innerHTML, textContent } = childNode.firstChild.parentElement;
                        const indexOffset = innerHTML.indexOf(textContent);
        
                        if (indexOffset === -1) {
                            passageHTML += innerHTML;
                            break;
                        }
                        
                        passageHTML += innerHTML.slice(0, indexOffset);
        
                        if (startIndex >= lastIndex && endIndex <= lastIndex + textContent.length) {
                            passageHTML += textContent.slice(0, startIndex - lastIndex);
                            passageHTML += '<mark>';
                            passageHTML += textContent.slice(startIndex - lastIndex, endIndex - lastIndex);
                            passageHTML += '</mark>';
                            passageHTML += textContent.slice(endIndex - lastIndex, textContent.length);
                            passagePreview += innerHTML.slice(0, indexOffset);
                            passagePreview += textContent.slice(startIndex - lastIndex, endIndex - lastIndex);
                            passagePreview += innerHTML.slice(indexOffset + textContent.length);
                        }
                        else if (startIndex >= lastIndex && startIndex < lastIndex + textContent.length) {
                            passageHTML += textContent.slice(0, startIndex - lastIndex);
                            passageHTML += '<mark>';
                            passageHTML += textContent.slice(startIndex - lastIndex, textContent.length);
                            passageHTML += '</mark>';
                            passagePreview += innerHTML.slice(0, indexOffset);
                            passagePreview += textContent.slice(startIndex - lastIndex, textContent.length);
                            passagePreview += innerHTML.slice(indexOffset + textContent.length);
                        }
                        else if (endIndex >= lastIndex && endIndex < lastIndex + textContent.length) {
                            passageHTML += '<mark>';
                            passageHTML += textContent.slice(0, endIndex - lastIndex);
                            passageHTML += '</mark>';
                            passageHTML += textContent.slice(endIndex - lastIndex, textContent.length);
                            passagePreview += innerHTML.slice(0, indexOffset);
                            passagePreview += textContent.slice(0, endIndex - lastIndex);
                            passagePreview += innerHTML.slice(indexOffset + textContent.length);
                        }
                        else if (startIndex <= lastIndex && endIndex >= lastIndex + textContent.length) {
                            passageHTML += '<mark>';
                            passageHTML += textContent;
                            passageHTML += '</mark>';
                            passagePreview += innerHTML.slice(0, indexOffset);
                            passagePreview += textContent;
                            passagePreview += innerHTML.slice(indexOffset + textContent.length);
                        }
                        else {
                            passageHTML += textContent;
                        }
        
                        passageHTML += innerHTML.slice(indexOffset + textContent.length);
                    
                        lastIndex += textContent.length;
                    }
                }
                else {
                    const { textContent } = childNode;
    
                    if (startIndex >= lastIndex && endIndex <= lastIndex + textContent.length) {
                        passageHTML += textContent.slice(0, startIndex - lastIndex);
                        passageHTML += '<mark>';
                        passageHTML += textContent.slice(startIndex - lastIndex, endIndex - lastIndex);
                        passageHTML += '</mark>';
                        passageHTML += textContent.slice(endIndex - lastIndex, textContent.length);
                        passagePreview += textContent.slice(startIndex - lastIndex, endIndex - lastIndex);
                    }
                    else if (startIndex >= lastIndex && startIndex < lastIndex + textContent.length) {
                        passageHTML += textContent.slice(0, startIndex - lastIndex);
                        passageHTML += '<mark>';
                        passageHTML += textContent.slice(startIndex - lastIndex, textContent.length);
                        passageHTML += '</mark>';
                        passagePreview += textContent.slice(startIndex - lastIndex, textContent.length);
                    }
                    else if (endIndex >= lastIndex && endIndex < lastIndex + textContent.length) {
                        passageHTML += '<mark>';
                        passageHTML += textContent.slice(0, endIndex - lastIndex);
                        passageHTML += '</mark>';
                        passageHTML += textContent.slice(endIndex - lastIndex, textContent.length);
                        passagePreview += textContent.slice(0, endIndex - lastIndex);
                    }
                    else if (startIndex <= lastIndex && endIndex >= lastIndex + textContent.length) {
                        passageHTML += '<mark>';
                        passageHTML += textContent;
                        passageHTML += '</mark>';
                        passagePreview += textContent;
                    }
                    else {
                        passageHTML += textContent;
                    }
    
                    lastIndex += textContent.length;
                }
            }

            newAnnotations[i].html = passageHTML;
            newAnnotations[i].preview = passagePreview;
        }

        setAnnotations(newAnnotations);
    }

    const renderKatex = () => {
        const katex = document.getElementsByClassName('katex');
        for (let i = 0; i < katex.length; i++) {
            renderMathInElement(katex[i], {
                delimiters: [
                    {left: '$$', right: '$$', display: true},
                    {left: '$', right: '$', display: false},
                    {left: '\\(', right: '\\)', display: false},
                    {left: '\\[', right: '\\]', display: true}
                ],
                trust: true
            });

            katex[i].innerHTML = katex[i].innerHTML.replaceAll('&nbsp;', ' ');
        }

        const wrappingTexts = document.querySelectorAll<HTMLElement>('.katex-html .base');
        for (let i = 0; i < wrappingTexts.length; i++) {
            // console.log(wrappingTexts[i]);
            if (testModules[moduleIndex].subject === 'ACT Reading' || testModules[moduleIndex].subject === 'ACT English'|| testModules[moduleIndex].subject === 'ACT Science') {
                wrappingTexts[i].classList.add('wrap');
            }
            else {
                wrappingTexts[i].classList.remove('wrap');
            }
        }

        const underlines = document.querySelectorAll<HTMLElement>('.katex-html .base .underline');
        for (let i = 0; i < underlines.length; i++) {
            if (underlines[i].querySelector('mark')) {
                continue;
            }
            underlines[i].innerHTML = underlines[i].innerText;
        }

        const math = document.querySelectorAll('.katex-mathml');
        for (let i = 0; i < math.length; i++) {
            math[i].remove();
        }
    }

    const dragMove = (element: HTMLElement, header: HTMLElement) => {
        let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    
        const dragMouseDown = (event) => {
            event.preventDefault();
    
            if (event.type === 'mousedown') {
                pos3 = event.clientX;
                pos4 = event.clientY;
                document.onmousemove = dragElement;
                document.onmouseup = closeDragElement;
            } else if (event.type === 'touchstart') {
                pos3 = event.touches[0].clientX;
                pos4 = event.touches[0].clientY;
                document.ontouchmove = dragElement;
                document.ontouchend = closeDragElement;
            }
        };
    
        const dragElement = (event) => {
            event.preventDefault();
    
            if (event.type === 'mousemove') {
                pos1 = pos3 - event.clientX;
                pos2 = pos4 - event.clientY;
                pos3 = event.clientX;
                pos4 = event.clientY;
            } else if (event.type === 'touchmove') {
                pos1 = pos3 - event.touches[0].clientX;
                pos2 = pos4 - event.touches[0].clientY;
                pos3 = event.touches[0].clientX;
                pos4 = event.touches[0].clientY;
            }
    
            if (pos3 > 0 && pos4 > 0 && pos3 < window.innerWidth && pos4 < window.innerHeight) {
                element.style.top = (element.offsetTop - pos2) + 'px';
                element.style.left = (element.offsetLeft - pos1) + 'px';
            }
            else {
                document.onmouseup(event);
                closeDragElement();
            }
        };
    
        const closeDragElement = () => {
            document.onmouseup = null;
            document.onmousemove = null;
            document.ontouchend = null;
            document.ontouchmove = null;
        };
    
        header.onmousedown = (event) => {
            if (event.target instanceof Element && (event.target.closest('.digitalACTReview__popupHeaderIcon') || event.target.closest('.digitalACTReview__popupHeaderFull'))) {
                return;
            }
            dragMouseDown(event);
        };
    
        header.ontouchstart = (event) => {
            if (event.target instanceof Element && (event.target.closest('.digitalACTReview__popupHeaderIcon') || event.target.closest('.digitalACTReview__popupHeaderFull'))) {
                return;
            }
            dragMouseDown(event);
        };
    };

    useEffect(() => {
        axios.get(`tests/digital/act/review/${testId}/`)
            .then(res => {
                setStudentName(res.data.studentName);
                setTestModules(res.data.testModules);
            })
            .catch(error => {
                // console.log(error);
                dispatch(setError(error));
            });
    }, []);

    // passage scroll, passage magnifier scroll (according to the highliting index)
    useLayoutEffect(() => {
        if (highlighting.length > 0) {
            const passageId = highlighting[0].passageId;
            const passage = document.getElementById(`highlighting ${passageId}`);
            // highlighting 여러개일 경우 첫 번째 
            if (passage) {
                let firstHighlight = passage.querySelector("mark"); // 첫 번째 mark 태그 찾기
                let offset = 0;
                while (firstHighlight !== passage) {
                    offset = firstHighlight.offsetTop;
                    firstHighlight = firstHighlight.parentElement;
                }
                if (firstHighlight && passageContainerRef.current) {
                    passageContainerRef.current.scrollTo({
                        top: firstHighlight? offset - passageContainerRef.current.offsetTop: 0,
                        behavior: "smooth", 
                    });
                }
            }
        }
    }, [highlighting]);

    useEffect(() => {
        if (testModules) {
            let calculatorEl = document.getElementById('calculator');
            setCalculator(Desmos.GraphingCalculator(calculatorEl, {
                notes: false,
                folders: false,
                images: false,
                links: false
            }));

            // dragMove(document.getElementById('calculatorDrag'), document.getElementById('calculatorHeader'));
            const calculatorDragEl = document.getElementById('calculatorDrag');
            const calculatorHeaderEl = document.getElementById('calculatorHeader');
            if (calculatorDragEl && calculatorHeaderEl) {
                dragMove(calculatorDragEl, calculatorHeaderEl);
            }
        }
    }, [testModules]);

    useLayoutEffect(() => {
        if (testModules) {
            renderKatex();
            generateAnnotation();
            setHighlighting([]);
            setFullPassage(null);
            const passageData = testModules[moduleIndex].questions[questionIndex]?.passages;
            if (passageData) {
                const { id, indices, passageFigures } = testModules[moduleIndex].questions[questionIndex].passages
                if (indices) generateHightlightIndexing({ id, indices, passageFigures });  
                getPassageWithFigure({ id, passageFigures });
            }
        }
    }, [testModules, moduleIndex, questionIndex]);

    useEffect(() => {
        if (testModules) {
            renderKatex();
        }
    }, [directionsOpen]);
    
    useEffect(() => {
        if (fullPassage) {
            generateAnnotation();
        }
    }, [fullPassage]);
    
    // useEffect(() => {
    //     if (testModules) {
    //         // renderKatex();
    //     }
    // }, [questionIndex, testModules, fullPassage, highlighting]);

    useEffect(() => {
        if (calculatorOpen) {
            calculator.focusFirstExpression();
        }
    }, [calculatorOpen]);

    if (testModules === null) return <Loader />;

    const {
        name,
        questions,
        answers,
        subject,
        prompt
    } = testModules[moduleIndex];

    return (
        <div className='digitalACTReviewBox' onCopy={(event) => { event.preventDefault() }}>
            {/* {explanationVideo &&
                <Popup
                    secondaryButtonText='CLOSE'
                    secondaryButtonOnClick={() => setExplanationVideo(null)}
                    innerRef={explanationRef}
                >
                    <div className='digitalACTReview__videoContainer'>
                        <div id='vimeoPlayer'></div>
                    </div>
                </Popup>
            } */}
            <Helmet title={`${name} Review | PrepSharp Students`} />
            <div className='digitalACTReview'>
                <div className='digitalACTReview__header'>
                    <div className='digitalACTReview__titleGroup'>
                        <button className='digitalACTReview__moduleSelect' onClick={() => setModuleSelectOpen(!moduleSelectOpen)}>
                            <h1 className='digitalACTReview__title'>
                                {subject.replace('ACT ', '')}
                            </h1>
                            {moduleSelectOpen
                                ? <MdKeyboardArrowUp className='digitalACTReview__moduleSelectIcon' />
                                : <MdKeyboardArrowDown className='digitalACTReview__moduleSelectIcon' />
                            }
                            {moduleSelectOpen &&
                                <div className='digitalACTReview__moduleSelectDropdown' ref={moduleSelectRef}>
                                    {testModules.map((testModule, t) => (
                                        <p
                                            className={t === moduleIndex
                                                ? 'digitalACTReview__moduleSelectDropdownItem--selected'
                                                : 'digitalACTReview__moduleSelectDropdownItem'
                                            }
                                            onClick={() => {
                                                if (t !== moduleIndex) {
                                                    setModuleIndex(t);
                                                    setQuestionIndex(0);
                                                }
                                            }}
                                        >
                                            {testModule.subject.replace('ACT ', '')}
                                        </p>
                                    ))}
                                </div>
                            }
                        </button>
                        <div className='digitalACTReview__titleGroupRow'>
                            <button className='digitalACTReview__directionsButton' onClick={() => setDirectionsOpen(!directionsOpen)}>
                                {directionsOpen
                                    ? <u>Directions</u>
                                    : <p>Directions</p>
                                }
                                {directionsOpen
                                    ? <MdKeyboardArrowUp className='digitalACTReview__directionsIcon' />
                                    : <MdKeyboardArrowDown className='digitalACTReview__directionsIcon' />
                                }
                            </button>
                            <div className='digitalACTReview__mode'>
                                {/* <IoEye className='digitalACTReview__modeIcon' /> */}
                                <p className='digitalACTReview__modeText'>REVIEW MODE</p>
                                <MdInfo
                                    className='digitalACTReview__modeInfo'
                                    onClick={() => {
                                        setModeInfo(!modeInfo)
                                        setNotScored(false)
                                    }}
                                    onMouseEnter={() => setModeInfoHover(true)}
                                    onMouseLeave={() => setModeInfoHover(false)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='digitalACTReview__timerGroup'>
                        <p className='digitalACTReview__timer'>
                            {formatTime(answers[questionIndex].timeSpent)}
                        </p>
                        <p className='digitalACTReview__timerText'>
                            Time spent
                        </p>
                    </div>
                    <div className='digitalACTReview__actionGroup'>
                        {subject === 'ACT Mathematics' && <>
                            <button 
                                className={calculatorOpen
                                    ? 'digitalACTReview__action--active'
                                    : 'digitalACTReview__action'
                                }
                                onClick={() => {
                                    setCalculatorOpen(!calculatorOpen);
                                }}
                            >
                                <MdOutlineCalculate className='digitalACTReview__actionIcon' />
                                <p className='digitalACTReview__actionText'>Calculator</p>
                            </button>
                        </>}
                        <button
                            className='digitalACTReview__action'
                            onClick={() => navigate(-1)}
                            // onClick={() => navigate(`/report/digital-sat/${testId}`)}
                        >
                            <MdExitToApp className='digitalACTReview__actionIcon' />
                            <p className='digitalACTReview__actionText'>Exit</p>
                        </button>
                    </div>
                    {directionsOpen &&
                        <div className='digitalACTReview__directions' ref={directionsRef}>
                            <div className='digitalACTReview__directionsBubble'>
                                <p className='katex digitalACTReview__directionsText'>
                                    {prompt
                                        ? prompt
                                        : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sollicitudin, mi congue condimentum dignissim, ipsum diam tristique velit, et rutrum orci massa non purus. Etiam vitae ante sed velit blandit condimentum. Donec lectus ipsum, volutpat vel tortor a, blandit elementum felis. Mauris a ultricies quam, at molestie ipsum. Cras nec ante justo. Suspendisse egestas lectus sit amet sem maximus auctor. In ut dignissim lorem, ac tristique eros. Nullam eget sollicitudin quam. Quisque pellentesque cursus justo sed ornare. Integer finibus, tortor at facilisis molestie, ligula augue cursus ipsum, eget auctor enim sem a eros. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Pellentesque suscipit, nunc eget mollis consequat, augue odio suscipit enim, vel varius eros leo sit amet magna. Nunc suscipit leo et metus bibendum, a finibus libero finibus. In lacinia scelerisque urna ut pretium. In at est aliquam, dictum odio non, fringilla tellus. Vivamus commodo molestie urna at dapibus. Nulla facilisi. Maecenas sit amet lorem tincidunt, maximus nunc eu, malesuada velit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla facilisi.'
                                    }
                                </p>
                                <Button
                                    className='digitalACTReview__directionsClose'
                                    onClick={() => setDirectionsOpen(false)}
                                    secondary
                                >
                                    CLOSE
                                </Button>
                            </div>
                        </div>
                    }
                    {(modeInfo || modeInfoHover) &&
                        <div className='digitalACTReview__modePopup'>
                            <IoCloseCircle className='digitalACTReview__modeClose' onClick={() => setModeInfo(false)} />
                            <p>
                                <i>Review Mode</i> enables you to review your completed practice test (for test section).
                                <br/><br/>
                                Test questions answered correctly are marked in <span className='digitalACTReview__modePopupGreen'>green</span> while incorrect responses are marked in <span className='digitalACTReview__modePopupRed'>red</span> for each item. Use the <i>Show Answer</i> button on any test question to reveal the credited response.
                                <br/><br/>
                                In addition, the Question Menu in the footer expands to provide a quick, color-coded overview of your performance.
                            </p>
                        </div>
                    }
                    <div id='calculatorDrag' className={calculatorOpen
                        ? (calculatorFull
                            ? 'digitalACTReview__popup--calculatorFull'
                            : 'digitalACTReview__popup--calculator'
                          )
                        : 'digitalACTReview__popup--hidden'
                    }>
                        <div id='calculatorHeader' className='digitalACTReview__popupHeader'>
                            <h3 className='digitalACTReview__popupHeaderText'>Scientific Calculator</h3>
                            {calculatorFull
                                ? <MdCloseFullscreen className='digitalACTReview__popupHeaderFull' onClick={() => setCalculatorFull(false)} />
                                : <MdOpenInFull className='digitalACTReview__popupHeaderFull' onClick={() => setCalculatorFull(true)} />
                            }
                            <MdClose className='digitalACTReview__popupHeaderIcon' onClick={() => setCalculatorOpen(false)} />
                        </div>
                        <div
                            id='calculator'
                            style={{ width: calculatorFull ? 800 : 400, height: 600 }}
                        ></div>
                    </div>
                </div>
                <div className='digitalACTReview__dottedLine'></div>
                <div className='digitalACTReview__test'>
                    {questions[questionIndex].passages && <>
                        <div className='digitalACTReview__material' ref = {passageContainerRef}>
                            <div className='digitalACTReview__materialContent'>
                                {/* {questions[questionIndex].figures.map(figure => (
                                    <img
                                        className='digitalACTReview__figure'
                                        key={figure.id}
                                        src={figure.image}
                                        alt={(questionIndex + 1).toString()}
                                    />
                                ))} */}
                                <div key={questions[questionIndex].passages.id} className='digitalACTReview__passage'>
                                    {/* 해당 id를 가진 passage의 p태그 가져와서 highlight 넣은 html 받아와서 겹쳐 보여줌 (z-index, transparent 조절) */}
                                    <p
                                        id={questions[questionIndex].passages.id}
                                        className='katex digitalACTReview__passageText'
                                    >
                                        {questions[questionIndex].passages.passage}
                                    </p>
                                    <p
                                        id={`passage ${questions[questionIndex].passages.id}`}
                                        className='katex digitalACTReview__passageTextPassage'
                                        dangerouslySetInnerHTML={{ __html: fullPassage?.html }}
                                    >
                                    </p>
                                    {/* {questionNumber > 0 &&  */}
                                    {highlighting.length > 0 &&
                                        highlighting.map((highlight, index)=>
                                            <div
                                                id={`highlighting ${questions[questionIndex].passages.id}`}
                                                key={index}
                                                className='katex digitalACTReview__Highlight'
                                                dangerouslySetInnerHTML={{ __html: highlight?.html }}
                                            ></div>
                                        )
                                    }
                                    {
                                        answers[questionIndex].annotations.filter(annotation => (
                                            annotation.passageId === `${questions[questionIndex].passages.id}`
                                        )).map((annotation, a) => <>
                                            <div
                                                className='katex digitalACTReview__passageAnnotation'
                                                dangerouslySetInnerHTML={{ __html: annotation.html }}
                                            ></div>
                                        </>)
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='digitalACTReview__verticalLine'></div>
                    </>}
                    <div className='digitalACTReview__question'>
                        <div className='digitalACTReview__questionContent'>
                            <div className='digitalACTReview__questionHeader'>
                                <div className='digitalACTReview__leftButton'>
                                    <p className={answers[questionIndex].isCorrect
                                        ? 'digitalACTReview__questionNumber--correct'
                                        : 'digitalACTReview__questionNumber--wrong'
                                    }>
                                        {questionIndex + 1}
                                    </p>
                                    <button className='digitalACTReview__questionMarkButton' onClick={() => {}}>
                                        {answers[questionIndex].marked
                                            ? <MdOutlineBookmark className='digitalACTReview__questionMarkIcon--marked' />
                                            : <MdOutlineBookmarkBorder className='digitalACTReview__questionMarkIcon' />
                                        }
                                        Flag
                                    </button>
                                </div>
                                {questions[questionIndex].notScored && <div className='digitalACTReview__notScored'>
                                    <div>Not Scored</div>
                                    <IoMdInformationCircleOutline 
                                        className='digitalACTReview__notScoredIcon'
                                        onClick={() => {setNotScored(!notScored)
                                                        setModeInfo(false)
                                        }}
                                        onMouseEnter={() => setNotScoredHover(true)}
                                        onMouseLeave={() => setNotScoredHover(false)}
                                    />
                                </div>}

                                {/* {!DISABLE_TEST_REVIEW_SHOW_ANSWER.includes(organization.alias) &&
                                    <button
                                        className={showAnswer
                                            ? 'digitalACTReview__showAnswer--active'
                                            : 'digitalACTReview__showAnswer'
                                        }
                                        onClick={() => setShowAnswer(!showAnswer)}
                                    >
                                        {showAnswer ? 'Hide answer' : 'Show answer'}
                                    </button>
                                } */}
                            </div>
                            <div id='digitalACTReview__questionChoices' className='digitalACTReview__questionChoices'>
                                <p className='digitalACTReview__questionQuestionContainer'>
                                    <span className='katex digialACTReview__questionQuestion'>
                                        {questions[questionIndex].question}
                                    </span>
                                    {questions[questionIndex].figures &&
                                        questions[questionIndex].figures.map(figure => (
                                            <img
                                                className='digitalACTReview__figure'
                                                key={figure.id}
                                                src={figure.image}
                                                alt={(questionIndex + 1).toString()}
                                            />
                                        ))
                                    }
                                </p>
                                {questions[questionIndex].choices.length
                                ?   <>
                                        {questions[questionIndex].choices.map((choice, i) => (
                                            <div key={choice.id} className='digitalACTReview__questionChoiceWrapper'>
                                                <div 
                                                    className='digitalACTReview__choiceContainer'
                                                >
                                                    <div
                                                        className={showAnswer && choice.isCorrect
                                                            ? 'digitalACTReview__radioButton--correct'
                                                            : answers[questionIndex].answer == choice.id
                                                            ? (choice.isCorrect 
                                                                ? 'digitalACTReview__radioButton--selected'
                                                                : 'digitalACTReview__radioButton--wrong'
                                                            )
                                                            : 'digitalACTReview__radioButton'
                                                    }>
                                                        {showAnswer && choice.isCorrect || answers[questionIndex].answer == choice.id?
                                                            <IoMdRadioButtonOn className='digitalACTReview__radioButtonIcon'/>
                                                            : <IoMdRadioButtonOff className='digitalACTReview__radioButtonIcon'/>
                                                        }
                                                    </div>
                                                    <div className={showAnswer && choice.isCorrect
                                                        ? 'digitalACTReview__questionChoiceContent--correct'
                                                        : answers[questionIndex].answer == choice.id
                                                        ? (choice.isCorrect 
                                                            ? 'digitalACTReview__questionChoiceContent--selected'
                                                            : 'digitalACTReview__questionChoiceContent--wrong'
                                                        )
                                                        : 'digitalACTReview__questionChoiceContent'
                                                    }>
                                                        <p className={showAnswer && choice.isCorrect
                                                            ? 'digitalACTReview__choiceText--correct'
                                                            : answers[questionIndex].answer == choice.id
                                                            ? (choice.isCorrect 
                                                                ? 'digitalACTReview__choiceText--selected'
                                                                : 'digitalACTReview__choiceText--wrong'
                                                            )
                                                            : 'digitalACTReview__choiceText'
                                                        }>
                                                            {MULTIPLE_CHOICES[i]}.
                                                        </p>
                                                        {choice.figure
                                                        ?   <img
                                                                className='digitalACTReview__questionChoiceFigure'
                                                                key={choice.figure}
                                                                src={choice.figure}
                                                                alt={choice.figure}
                                                            />
                                                        :   <p className='digitalACTReview__questionChoiceText'>
                                                                <span className='katex'>
                                                                    {choice.choice}
                                                                </span>
                                                            </p>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                :   <div className='digitalACTReview__questionAnswerReview'>
                                        <TextInput
                                            className='digitalACTReview__questionAnswer'
                                            inputClassName='digitalACTReview__questionAnswerInput'
                                            name={name + questionIndex}
                                            value={answers[questionIndex].answer
                                                ? answers[questionIndex].answer
                                                : ''
                                            }
                                            onChange={() => {}}
                                        />
                                        {showAnswer &&
                                            <p className='digitalACTReview__questionCorrectAnswer'>
                                                {questions[questionIndex].correctAnswers.toString().replaceAll(',', ', ')}
                                            </p>
                                        }
                                    </div>
                                }
                                <div className='digitalACTReview__marginBottom'></div>
                            </div>
                        </div>
                    </div>
                    {((notScored || notScoredHover) && questions[questionIndex].notScored) && 
                        <div className='digitalACTReview__notScoredPopup'>
                            <IoCloseCircle className='digitalACTReview__notScoredClose' onClick={() => setNotScored(false)} />
                            <p>On test day, each section of the ACT will include a preset number of experimental questions called "field-test items."  These questions will not be scored and will vary in location on each exam.  To replicate actual test conditions as closely as possible, PrepSharp exams similarly include the same number of unscored questions as on the ACT and with the same variable arrangements.  That way, tutors can provide their students a testing experience that is truly representative of what they will face on test day.</p>
                        </div>
                    }
                </div>
                <div className='digitalACTReview__dottedLine'></div>
                <div className='digitalACTReview__footer'>
                    {/* {questions[questionIndex].explanationVideo
                    ?   <div className='digitalACTReview__buttons'>
                            <Button
                                className='digitalACTReview__explanationButton'
                                onClick={() => setExplanationVideo(questions[questionIndex].explanationVideo)}
                            >
                                SOLUTION VIDEO
                                <MdOutlinePlayCircle className='digitalACTReview__explanationButtonIcon' />
                            </Button>
                        </div>
                    :    <p className='digitalACTReview__tester'>
                            {studentName}
                        </p>
                    } */}
                    <p className='digitalACTReview__tester'>
                        {studentName}
                    </p>
                    <button
                        className='digitalACTReview__navigatorToggle'
                        onClick={() => {
                            setNavigatorOpen(!navigatorOpen)
                            setModeInfo(false)
                            setNotScored(false)
                        }}   
                    >
                        Question {questionIndex + 1}/{questions.length}
                        {navigatorOpen
                            ? <MdKeyboardArrowDown className='digitalACTReview__navigatorToggleIcon' />
                            : <MdKeyboardArrowUp className='digitalACTReview__navigatorToggleIcon' />
                        }
                    </button>
                    <div className='digitalACTReview__buttons'>
                        <Button
                            className='digitalACTReview__button'
                            secondary
                            disabled={moduleIndex === 0 && questionIndex === 0}
                            onClick={prevQuestion}
                        >
                            BACK
                        </Button>
                        <Button
                            className='digitalACTReview__button'
                            onClick={nextQuestion}
                        >
                            NEXT
                        </Button>
                    </div>
                    {navigatorOpen &&
                        <div className='digitalACTReview__navigator' ref={navigatorRef}>
                            <div className='digitalACTReview__navigatorBubble'>
                                <h2 className='digitalACTReview__navigatorTitle'>
                                    {name} Questions
                                </h2>
                                <div className='digitalACTReview__navigatorLegends'>
                                    <div className='digitalACTReview__navigatorLegend'>
                                        <MdOutlineLocationOn className='digitalACTReview__navigatorLegendCurrent' />
                                        <p className='digitalACTReview__navigatorLegendText'>
                                            Current
                                        </p>
                                    </div>
                                    <div className='digitalACTReview__navigatorLegend'>
                                        <div className='digitalACTReview__navigatorLegendCorrect'></div>
                                        <p className='digitalACTReview__navigatorLegendText'>
                                            Correct
                                        </p>
                                    </div>
                                    <div className='digitalACTReview__navigatorLegend'>
                                        <div className='digitalACTReview__navigatorLegendWrong'></div>
                                        <p className='digitalACTReview__navigatorLegendText'>
                                            Incorrect
                                        </p>
                                    </div>
                                    <div className='digitalACTReview__navigatorLegend'>
                                        <div className='digitalACTReview__navigatorLegendNotScored' />
                                        <p className='digitalACTReview__navigatorLegendText'>
                                            Not Scored
                                        </p>
                                        <IoMdInformationCircleOutline 
                                            className='digitalACTReview__navigatorNotScoredIcon' 
                                            onClick={() => setNavigatorNotScored(!navigatorNotScored)}
                                            onMouseEnter={() => setNavigatorNotScoredHover(true)}
                                            onMouseLeave={() => setNavigatorNotScoredHover(false)}
                                        />
                                    </div>
                                    <div className='digitalACTReview__navigatorLegend'>
                                        <MdOutlineBookmark className='digitalACTReview__navigatorLegendMarked' />
                                        <p className='digitalACTReview__navigatorLegendText'>
                                            For review
                                        </p>
                                    </div>
                                </div>
                                <div className='digitalACTReview__navigatorItems'>
                                    {questions.map((question, i) => (
                                        <button
                                            key={`${question.id}nav`}
                                            className={`${answers[i].isCorrect
                                                ? 'digitalACTReview__navigatorItem--correct'
                                                : 'digitalACTReview__navigatorItem--wrong'}
                                                ${question.notScored && 'digitalACTReview__navigatorItem--notScored'}
                                                `
                                            }
                                            onClick={() => {
                                                goToQuestion(i);
                                                setNavigatorOpen(false);
                                            }}
                                        >
                                            {questionIndex === i
                                                ? <u className='digitalACTReview__navigatorItemNumber'>{i + 1}</u>
                                                : <p className='digitalACTReview__navigatorItemNumber'>{i + 1}</p>
                                            }
                                            {questionIndex === i && <MdOutlineLocationOn className='digitalACTReview__navigatorItemCurrent' />}
                                            {answers[i].marked && <MdOutlineBookmark className='digitalACTReview__navigatorItemMarked' />}
                                        </button>
                                    ))}
                                </div>
                                {(navigatorNotScored || navigatorNotScoredHover) && 
                                    <div className='digitalACTReview__navigatorNotScoredPopup'>
                                        <IoCloseCircle className='digitalACTReview__notScoredClose' onClick={() => setNavigatorNotScored(false)} />
                                        <p>On test day, each section of the ACT will include a preset number of experimental questions called "field-test items."  These questions will not be scored and will vary in location on each exam.  To replicate actual test conditions as closely as possible, PrepSharp exams similarly include the same number of unscored questions as on the ACT and with the same variable arrangements.  That way, tutors can provide their students a testing experience that is truly representative of what they will face on test day.</p>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default DigitalACTReview;